export const BRAND_NAME = 'Realush';
export const BRAND_EMAIL = 'idan@f-narrative.co.il';
export const STORAGE_KEYS = {
    user: 'User',
    accessToken: 'AccessToken',
    messageSound: 'MessageSound',
    orientation: 'Orientation',
    ageGroup: 'AgeGroup',
    country: 'Country',
    note: 'Note',
    noteBank: 'NoteBank',
    feedbackModalCount: 'Feedback modal count',
    speedDatingFilters: 'Speed Dating filters',
    backgroundMusicVolume: 'Background music volume',
    reloadCount: 'Reload count',
    enterByInvite: 'Enter by invite',
    invitedBy: 'Invited by',
    showVideoSDKVideoStatus: 'Show video stats',
    showExplicitContentCheck: 'Show explicit content check',
    explicitContent: 'Explicit Content',
    friendsRequest: 'Friend Request',
    backgrounds: 'Backgrounds',
    firstMobileLogin: 'First Mobile Login',
    accessTokenTimestamp: 'Access Token Timestamp',
    RoomsComeAliveDuringEventsChecked: 'Is Rooms Come Alive During Events Checked',
    WelcomeToTheRoom: 'Welcome To The Room',
    verified: 'Verified',
    userName: 'UserName',
};
export const SOCIAL_MEDIA = {
    facebook: 'https://www.facebook.com/RealushDating',
    instagram: 'https://www.instagram.com/realush_dating',
    linkedin: 'https://www.linkedin.com/company/realush',
};
export const CHAT_USER_COLORS = [
    'red',
    'green',
    'blue',
    'yellow',
    'blueviolet',
    'coral',
    'darkgreen',
    'darkgray',
];
export var EventType;
(function (EventType) {
    EventType[EventType["SPEED_DATING"] = 19] = "SPEED_DATING";
})(EventType || (EventType = {}));
export const DEMO_ROOM_ID = 190;
